<template>
  <div>
    <div class="img-logout">
      <ImageNav />
      <Nav />
    </div>

    <div>
      <Header/>
    </div>

    <div>
      <Content/>
    </div>

    <div class="footer-gestion">
      <Footer/>
    </div>
  </div>
</template>

<script>
import Nav from "./components/Nav";
import Header from "./components/nav/Header.vue"
import Content from "./components/Content"
import Footer from '../../components/layout/Footer.vue';
import ImageNav from "./components/nav/ImageNav.vue";
export default {
  components: {
    Nav,
    Header,
    Content,
    Footer,
    ImageNav
  },
};
</script>
<style scoped>
.img-logout {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 50px
}
</style>

